import { render, staticRenderFns } from "./Findpassword.vue?vue&type=template&id=13ca8cc4&scoped=true&"
import script from "./Findpassword.vue?vue&type=script&lang=js&"
export * from "./Findpassword.vue?vue&type=script&lang=js&"
import style0 from "./Findpassword.vue?vue&type=style&index=0&id=13ca8cc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca8cc4",
  null
  
)

export default component.exports